export default __webpack_public_path__ + "static/media/photo--sm--141.37b5cdc2.jpg";